/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import AppDispatcher from '../../core/AppDispatcher'
import ApiClient from '../../ApiClient'
import LoginApi from '../../api/LoginApi'
import AutoActionApi from '../../api/AutoActionApi'
import ApiHandle from '../../util/ApiHandle'
import history from '../../util/history'
import { appActions } from '../AppActions'
import MailApi from '../../api/MailApi'

export const AutoMailActionTypes = {
  fetchRooms: 'auto_action/mails/fetch-room',
  fetchSiteReferrers: 'auto_action/mails/fetchSiteReferrers',
  fetchSmtpSettings: 'auto_action/mails/fetchSmtpSettings',
  fetchOne: 'auto_action/mails/fetch-one',
  fetchAll: 'auto_action/mails/fetch-all',
  onCreate: 'auto_action/mails/on-create',
  onEdit: 'auto_action/mails/on-edit'
}

const loginApi = new LoginApi(ApiClient.instance)
const autoActionApi = new AutoActionApi(ApiClient.instance)
const mailApi = new MailApi(ApiClient.instance)

const AutoMailActions = {
  fetchRooms: () => {
    const apiHandleOpts = {
      apiCall: () => loginApi.getUserRooms(),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchRooms, { rooms: response })
      },
      onErrored: error => {
        appActions.snackbar('宿情報の取得に失敗しました', 'error', true)
      }
    }
    ApiHandle(apiHandleOpts)
  },
  fetchSiteReferrers: type => {
    const apiHandleOpts = {
      apiCall: () => loginApi.getSiteReferrers({ site_referrers: { available_type: type } }),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchSiteReferrers, { site_referrers: response })
      },
      onErrored: () => {
        appActions.snackbar('OTA情報の取得に失敗しました', 'error', true)
      }
    }
    ApiHandle(apiHandleOpts)
  },

  fetchSmtpSettings: () => {
    const apiHandleOpts = {
      apiCall: () => mailApi.getSmtpSettings(),
      onSucceded: response => {
        AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchSmtpSettings, { smtp_settings: response })
      },
      onErrored: () => {
        appActions.snackbar('メール送信元の取得に失敗しました', 'error', true)
      }
    }
    ApiHandle(apiHandleOpts)
  },
  fetchOne: id => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.getAutoActionMail(id),
      onSucceded: response => AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchOne, response),
      onFailed: response => {},
      onErrored: error => {}
    }
    ApiHandle(apiHandleOpts)
  },

  fetchAll: () => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.getAutoActionMails(),
      onSucceded: response => AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchAll, { mails: response }),
      onFailed: response => {},
      onErrored: error => {}
    }
    ApiHandle(apiHandleOpts)
  },

  onCreate: () => {
    AppDispatcher.dispatchWithType(AutoMailActionTypes.onCreate)
    history.push(`/auto_action/mails/new`)
  },

  onCreateWithCopy: async id => {
    const response = await autoActionApi.getAutoActionMail(id).catch(e => e)
    if (response instanceof Error) {
      appActions.showAlert(response, 'コピーに失敗しました')
      return
    }

    AppDispatcher.dispatchWithType(AutoMailActionTypes.fetchOne, response)

    history.push(`/auto_action/mails/new`)
  },

  onUpdate: auto_action_mail => {
    history.push(`/auto_action/mails/${auto_action_mail.id}/edit`)
  },

  onEdit: e => {
    AppDispatcher.dispatchWithType(AutoMailActionTypes.onEdit, { name: e.target.name, value: e.target.value })
  },

  onCancel: () => {
    history.push(`/auto_action/mails`)
  },

  onRequestCreate: autoMailState => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.newAutoActionMail(autoMailState.getApiParameters()),
      onSucceded: response => {
        AutoMailActions.onCancel()
        appActions.snackbar('追加しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '登録に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestUpdate: autoMailState => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.updateAutoActionMail(autoMailState.auto_action_mail_id, autoMailState.getApiParameters()),
      onSucceded: response => {
        AutoMailActions.onCancel()
        appActions.snackbar('更新しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '更新に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  },

  onRequestDelete: id => {
    const apiHandleOpts = {
      apiCall: () => autoActionApi.deleteAutoActionMail(id),
      onSucceded: response => {
        AutoMailActions.onCancel()
        appActions.snackbar('削除しました', 'success', true)
      },
      onErrored: error => {
        appActions.showError(error.response.body, '削除に失敗しました')
      }
    }
    ApiHandle(apiHandleOpts)
  }
}

export default AutoMailActions
